import {proxy, subscribe} from 'valtio';
import type {
  GetNextBuyflowStepResponse,
  StaticIpWidget,
  ProductWidget,
  BuyflowWidget,
} from '@/lib/TypesOpenApi';
import {useWidget} from '../routing/StepsWizardContext';
import {
  type StepWidgetStore,
  StepsPath,
  stepsMap,
} from '../routing/StepsRouting';
import {setStaticIp, staticIp} from './CartStore';

const widget = stepsMap['STATIC_IP']!.store;

export type StaticProductWidget = ProductWidget & {
  isDefaultSelection: boolean;
};
export interface StaticIpPageWidget {
  widget: StepWidgetStore;
  content?: GetNextBuyflowStepResponse;
  contentWidget?: StaticIpWidget;
  products: Array<StaticProductWidget>;
  findProduct: (id: string) => ProductWidget | undefined;
}

export const staticIpWidget = proxy<StaticIpPageWidget>({
  widget,
  get content() {
    return this.widget.content;
  },
  get contentWidget() {
    const widgets =
      this.content?.buyflowStep.buyflowWidgets
        ?.map(({staticIpWidget}: BuyflowWidget) => {
          return staticIpWidget!;
        })
        .filter((w: BuyflowWidget) => !!w) || [];
    return widgets[0];
  },
  get products() {
    if (!this.contentWidget?.productWidgets.length) {
      return [];
    }

    return this.contentWidget.productWidgets;
  },

  findProduct(id: string) {
    return this.products.find(
      (product: ProductWidget) => product.productId === id,
    );
  },
});

subscribe(staticIpWidget.widget, () => {
  if (!staticIp.selected) {
    const defaultSelected = staticIpWidget.products.filter(
      ({isDefaultSelection}) => isDefaultSelection,
    )[0];

    if (defaultSelected) setStaticIp(defaultSelected);
  }
});

export const useStaticIpWidget = () =>
  useWidget(StepsPath.StaticIp, staticIpWidget);
